import { useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import ExpectedUnoactProjectTargetGroupModule from "../../Pages/ProjectInformationPage/ExpectedUnoactProjectTargetGroupModule";
import InformationTargetGroupProjectModule from "../../Pages/ProjectInformationPage/InformationTargetGroupProjectModule";
import ProjectInformationModule from "../../Pages/ProjectInformationPage/ProjectInformationModule";
import ProjectWorkPlanModule from "../../Pages/ProjectInformationPage/ProjectWorkPlanModule";
import SectoreInformationProjectUniquenessModule from "../../Pages/ProjectInformationPage/SectoreInformationProjectUniquenessModule";
import TeamMembersModule from "../../Pages/ProjectInformationPage/TeamMembersModule";
import Navbar from "../../Pages/NavBar";
import "./style.css";
import { useNavigate } from "react-router-dom";
import loadConfig from "../../Services/apiService";
import { useDispatch, useSelector } from "react-redux";
import UpdateProjectImpact from "../../Services/ProjectInformationPage/ExpectedUnoactProjectTargetGroup/UpdateProjectImpact";
import Swal from "sweetalert2";
import UpdateGenderMainstreaming from "../../Services/ProjectInformationPage/InformationAboutTheTargetGroup/UpdateGenderMainstreaming";
import UpdateInformationAboutProject from "../../Services/ProjectInformationPage/ProjectInformation/UpdateInformationAboutProject";
import UpdateSectoreInformationProject from "../../Services/ProjectInformationPage/SectoreInformationProject/UpdateSectoreInformationProject";
import UpdateProjectPlan from "../../Services/ProjectInformationPage/ProjectPlanDetails/UpdateProjectPlan";

import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";
import { UpdateInformationAboutProjectt } from "../../Redux/Reducers/ProjectInformationPage/ProjectInformation";
const ProjectInformationPage = (props) => {
  const dispatch = useDispatch();
  const AppGuid = useParams();
  //console.log(AppGuid.AppGuid, "sdkjkshdjjjddd");
  const [InformationProjectSup, setInformationProjectSup] = useState("");
  //معلومات عن الفئة المستهدفة ضمن المشروع
  const [TargetAudience, setTargetAudience] = useState("");
  //تفاصيل خطة عمل المشروع
  const [projectPlan, setprojectPlan] = useState("");
  //الأثر المتوقع للمشروع على الفئة المستهدفة ومعايير الاستدامة
  const [ImpactSustainability, setImpactSustainability] = useState("");
  //معلومات عن القطاع وأصالة المشروع
  const [SectorInfo, setsectorInfo] = useState("");
  //أعضاء فريق العمل - الخبرات السابقة - بناء وحشد الشراكات
  const [TeamPartnerships, setTeamPartnerships] = useState("");
  useEffect(() => {
    //console.log(props, "dfdfdfdf");

    if (AppGuid.AppGuid) {
      // If `AppGuid.AppGuid` has a value, set the respective states with URLs
      // that include the `AppGuid` parameter.
      setInformationProjectSup(
        `/manager/InformationProject/InformationProjectSub/${AppGuid.AppGuid}`
      );
      setTargetAudience(
        `/manager/InformationProject/TargetAudience/${AppGuid.AppGuid}`
      );
      setprojectPlan(
        `/manager/InformationProject/projectPlan/${AppGuid.AppGuid}`
      );
      setImpactSustainability(
        `/manager/InformationProject/ImpactSustainability/${AppGuid.AppGuid}`
      );
      setsectorInfo(
        `/manager/InformationProject/sectorInfo/${AppGuid.AppGuid}`
      );
      setTeamPartnerships(
        `/manager/InformationProject/TeamPartnerships/${AppGuid.AppGuid}`
      );
    } else {
      // If `AppGuid.AppGuid` does not have a value, set the states with default URLs
      // that do not include the `AppGuid` parameter.
      // Uncommented example code shows how URLs might have been set with `AppGuid.AppGuid`.
      // setInformationProjectSup(`/manager/InformationProject/InformationProjectSub/${AppGuid.AppGuid}`);
      setInformationProjectSup(`/InformationProject/InformationProjectSub`);
      setTargetAudience("/InformationProject/TargetAudience");
      setprojectPlan("/InformationProject/projectPlan");
      setImpactSustainability("/InformationProject/ImpactSustainability");
      setsectorInfo("/InformationProject/sectorInfo");
      setTeamPartnerships(`/InformationProject/TeamPartnerships`);
    }
  }, []);

  const state = useSelector((state) => {
    return {
      ExpectedProjectImpact: state.ExpectedProjectImpact.ExpectedProjectImpact,
      TargetInfo: state.TargetInfo.TargetInfo,
      ProjectInformation: state.ProjectInformation.ProjectInformation,
      ProjectPlanDetails: state.ProjectPlanDetails.ProjectPlanDetails,
      SectoreInformationProject:
        state.SectoreInformationProject.SectoreInformationProject,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      UpdateInfoAboutProject: state.ProjectInformation.UpdateInfoAboutProject,
    };
  });
  const [activePage, setActivePage] = useState(props.active);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [jsonData, setJsonData] = useState();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const handlePageClick = async (active, route) => {
    //console.log(
    //   state.ProjectInformation,
    //   "state.SectoreInformationProject"
    // );
    //[]
    // مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال

    const shouldDisableFields = !(
      state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      window.location.href.includes("manager") == false
    );

    if (!shouldDisableFields) {
      if (Object.keys(state.ExpectedProjectImpact).length !== 0) {
       await UpdateProjectImpact(
          state.ExpectedProjectImpact.pI_ExpectedProjectImpactOnTargetGroupId,
          state.ExpectedProjectImpact.expectedSocialImpact,
          state.ExpectedProjectImpact.projectImpactOnTargetGroupSkillsAcquired,
          state.ExpectedProjectImpact.projectSustainabilityPlan,
          state.ExpectedProjectImpact.knowledgeTransferPlan,
          state.ExpectedProjectImpact.aI_ApplicationInformationId
        );
      }
      if (Object.keys(state.TargetInfo).length !== 0) {
       await UpdateGenderMainstreaming(
          state.TargetInfo.tG_MainTargetedGroupId,
          state.TargetInfo.genderInclusionPlan,
          state.TargetInfo.aI_ApplicationInformationId
        );
      }

      //console.log("state.ProjectInformation", state.ProjectInformation);

      if (Object.keys(state.ProjectInformation).length !== 0) {
        const updated = await dispatch(
          UpdateInformationAboutProjectt({
            ...state.ProjectInformation,
          })
        );
        // if (updated.payload) {
        //   console.log(updated.payload, "updatedupdated");
        //   setActivePage(active);
        //   navigat(`/grants${route}`);
        // }
      }

      if (Object.keys(state.ProjectPlanDetails).length !== 0) {
        await UpdateProjectPlan(
          state.ProjectPlanDetails?.pS_ProjectSummaryId,
          state.ProjectPlanDetails?.mainActivitiesProjectImplementation,
          state.ProjectPlanDetails?.projectPhases,
          state.ProjectPlanDetails?.activitiesInSchools,
          state.ProjectPlanDetails?.educationalContentCreation,
          state.ProjectPlanDetails?.approvalsForSchoolProjects,
          state.ProjectPlanDetails?.plannedElectronicContentInfo,
          state.ProjectPlanDetails?.uniqueProjectValue,
          state.ProjectPlanDetails?.aI_ApplicationInformationId
        );
      }
      if (Object.keys(state.SectoreInformationProject).length !== 0) {
       await UpdateSectoreInformationProject(
          state.SectoreInformationProject.sO_sectorAndProjectOriginalityInfoId,
          state.SectoreInformationProject.competitorsIdentification,
          state.SectoreInformationProject.distinguishingFeaturesOfApplicant,
          state.SectoreInformationProject.reasonsSupportingFundingDecision,
          state.SectoreInformationProject.aI_ApplicationInformationId
        );
      }
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم حفظ المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1000,
        // width: "500px",
      });
    }
    setActivePage(active);
    navigat(`/grants${route}`);
  };
  const navigat = useNavigate();

  const dataJson = async () => {
    let jsonData = await loadConfig();
    // return jsonData;
    setJsonData(jsonData);
  };

  useEffect(() => {
    dataJson();
  }, []);
  return (
    <>
      {jsonData ? (
        <div className="ContainerSubNavBar" title="قائمة معلومات المشروع">
          <div className="menu-icon" onClick={toggleMenu}>
            <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
            <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
            <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
          </div>
          <div className={`SubNavBar ${isMenuOpen ? "open" : ""}`}>
            <div
              className={`page ${activePage === 0 ? "active" : ""}`}
              onClick={() => {
                handlePageClick(0, InformationProjectSup);
                toggleMenu(); // إغلاق القائمة عند النقر على العنصر
              }}
            >
              <div title={jsonData.InformationAbouTheProjectTap.nameEN}>
                {jsonData.InformationAbouTheProjectTap.nameAR}{" "}
              </div>
            </div>
            <div
              className={`page ${activePage === 1 ? "active" : ""}`}
              onClick={() => {
                handlePageClick(1, TargetAudience);
                toggleMenu();
              }}
              title={jsonData.InformationTargetGroupTap.nameEN}
            >
              <div> {jsonData.InformationTargetGroupTap.nameAR} </div>
            </div>
            <div
              className={`page ${activePage === 2 ? "active" : ""}`}
              onClick={() => {
                handlePageClick(2, projectPlan);
                toggleMenu();
              }}
              title={jsonData.DetailsOfTheProjectWorkPlanTap.nameEN}
            >
              <div> {jsonData.DetailsOfTheProjectWorkPlanTap.nameAR} </div>
            </div>
            <div
              className={`page ${activePage === 3 ? "active" : ""}`}
              onClick={() => {
                handlePageClick(3, ImpactSustainability);
                toggleMenu();
              }}
              title={jsonData.expectedImpactOfTheProjectTap.nameEN}
            >
              <div>{jsonData.expectedImpactOfTheProjectTap.nameAR}</div>
            </div>
            <div
              className={`page ${activePage === 4 ? "active" : ""}`}
              onClick={() => {
                handlePageClick(4, SectorInfo);
                toggleMenu();
              }}
              title={jsonData.InformationAboutTheSectorTap.nameEN}
            >
              <div>{jsonData.InformationAboutTheSectorTap.nameAR}</div>
            </div>
            <div
              className={`page ${activePage === 5 ? "active" : ""}`}
              onClick={() => {
                handlePageClick(5, TeamPartnerships);
                toggleMenu();
              }}
              title={jsonData.TeamMembersPreviousExperienceTap.nameEN}
            >
              <div>{jsonData.TeamMembersPreviousExperienceTap.nameAR}</div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default ProjectInformationPage;
